// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReminderCard_reminder__EqXdT {
  width: 100%;
  border-radius: 2rem;
  background-color: var(--color-white);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  padding: 2rem 2rem;
}
.ReminderCard_reminder__title__8Wd\\+D {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}
.ReminderCard_reminder__title__text__I1i8H {
  padding: 0;
  margin: 0;
  font-size: var(--default-font-size);
  font-weight: 700;
}
.ReminderCard_reminder__title__icon__BFSXc {
  font-size: 2.4rem;
}
.ReminderCard_reminder__title__icon__BFSXc > :not(:last-child) {
  margin-right: 1rem;
}
.ReminderCard_reminder__content__SYEoJ {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
.ReminderCard_reminder__list__ggKci {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  font-size: var(--default-font-small);
  cursor: pointer;
}
.ReminderCard_reminder__list__ggKci:not(:last-child) {
  margin-bottom: 2rem;
}
@media only screen and (max-width: 50em) {
  .ReminderCard_reminder__list__ggKci:not(:last-child) {
    margin-bottom: 4rem;
  }
}
.ReminderCard_reminder__list__check__HGHYP {
  width: 2rem;
  height: 2rem;
  border: 2px solid var(--color-primary);
  cursor: pointer;
  margin-right: 1rem;
}
.ReminderCard_reminder__list__details__fBnzG {
  margin-right: 1rem;
}
.ReminderCard_reminder__list__time__Pb2Vi {
  color: var(--color-primary);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/AppHome/ReminderCard.module.scss"],"names":[],"mappings":"AAEA;EACC,WAAA;EACA,mBAAA;EACA,oCAAA;EACA,4CAAA;EACA,sBAAA;EACA,kBAAA;AADD;AAGC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AADF;AAGE;EACC,UAAA;EACA,SAAA;EACA,mCAAA;EACA,gBAAA;AADH;AAIE;EACC,iBAAA;AAFH;AAGG;EACC,kBAAA;AADJ;AAMC;EACC,aAAA;EACA,sBAAA;EACA,sBAAA;AAJF;AAOC;EACC,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,oCAAA;EACA,eAAA;AALF;AAME;EACC,mBAAA;AAJH;AAKG;EAFD;IAGE,mBAAA;EAFF;AACF;AAIE;EACC,WAAA;EACA,YAAA;EACA,sCAAA;EACA,eAAA;EACA,kBAAA;AAFH;AAKE;EACC,kBAAA;AAHH;AAME;EACC,2BAAA;AAJH","sourcesContent":["@import '../variables/breakpoints';\n\n.reminder {\n\twidth: 100%;\n\tborder-radius: 2rem;\n\tbackground-color: var(--color-white);\n\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\tbox-sizing: border-box;\n\tpadding: 2rem 2rem;\n\n\t&__title {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tmargin-bottom: 2rem;\n\n\t\t&__text {\n\t\t\tpadding: 0;\n\t\t\tmargin: 0;\n\t\t\tfont-size: var(--default-font-size);\n\t\t\tfont-weight: 700;\n\t\t}\n\n\t\t&__icon {\n\t\t\tfont-size: 2.4rem;\n\t\t\t& > :not(:last-child) {\n\t\t\t\tmargin-right: 1rem;\n\t\t\t}\n\t\t}\n\t}\n\n\t&__content {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tbox-sizing: border-box;\n\t}\n\n\t&__list {\n\t\tdisplay: flex;\n\t\tjustify-content: space-evenly;\n\t\talign-items: center;\n\t\tfont-size: var(--default-font-small);\n\t\tcursor: pointer;\n\t\t&:not(:last-child) {\n\t\t\tmargin-bottom: 2rem;\n\t\t\t@media only screen and (max-width: $bp-medium) {\n\t\t\t\tmargin-bottom: 4rem;\n\t\t\t}\n\t\t}\n\t\t&__check {\n\t\t\twidth: 2rem;\n\t\t\theight: 2rem;\n\t\t\tborder: 2px solid var(--color-primary);\n\t\t\tcursor: pointer;\n\t\t\tmargin-right: 1rem;\n\t\t}\n\n\t\t&__details {\n\t\t\tmargin-right: 1rem;\n\t\t}\n\n\t\t&__time {\n\t\t\tcolor: var(--color-primary);\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"reminder": `ReminderCard_reminder__EqXdT`,
	"reminder__title": `ReminderCard_reminder__title__8Wd+D`,
	"reminder__title__text": `ReminderCard_reminder__title__text__I1i8H`,
	"reminder__title__icon": `ReminderCard_reminder__title__icon__BFSXc`,
	"reminder__content": `ReminderCard_reminder__content__SYEoJ`,
	"reminder__list": `ReminderCard_reminder__list__ggKci`,
	"reminder__list__check": `ReminderCard_reminder__list__check__HGHYP`,
	"reminder__list__details": `ReminderCard_reminder__list__details__fBnzG`,
	"reminder__list__time": `ReminderCard_reminder__list__time__Pb2Vi`
};
export default ___CSS_LOADER_EXPORT___;
